import { render } from "./InputRadio.vue?vue&type=template&id=27a52910"
import script from "./InputRadio.vue?vue&type=script&lang=js"
export * from "./InputRadio.vue?vue&type=script&lang=js"
script.render = render

export default script